import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { ServiceConfig } from './service-config';
import { Observable } from 'rxjs';
@Injectable()
export class GlobalService {

  public projectsSource = new Subject<any>();
  projectLoaded$ = this.projectsSource.asObservable();

  serviceData: string;
  projects: Object;
  query: any;

  private host = ServiceConfig.host;
  private httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private BASE_URL_PROJECTS = this.host + '/api/projects/';
  private BASE_URL_IP = this.host + '/api/fb-user-seeding/';

  constructor(private router: Router, private httpClient: HttpClient) {
  }

  getProjectId() {
    const routers = this.router.url.split('/');
    let projectId = '';
    if (routers.indexOf('project') > -1) {
      projectId = routers[2];
    }
    return projectId;
  }
  getDomainArtilce() {
    const routers = this.router.url.split('/');
    let domain = '';
    if (routers.length == 3) {
      domain = routers[2];
    }
    return domain;
  }


  getGeneralReportByProject() : Observable<any>{
    let httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')) ? JSON.parse(localStorage.getItem('currentSmmData')).token : null);
    return this.httpClient.get(this.BASE_URL_PROJECTS + '/generalReport', { params: httpParams, headers: this.httpHeaders });
  }

  getIP() : Observable<any>{
    return this.httpClient.get(this.BASE_URL_IP + 'getIp', { headers: this.httpHeaders });
  }

  setProjects(projects: any) {
    this.projects = {};
    for (const project of projects) {
      this.projects[project['_id']] = project;
    }
    this.projectsSource.next(this.projects);
  }

  extractIdFromLink(id) {
    let temp = [];
    id = id.replace('https://', '');
    if (id.indexOf('/') > -1) {
      temp = id.split('/');
      id = temp[1];
    }
    if (id.indexOf('id=') > -1) {
      id = id.substring(id.indexOf('id=') + 3, id.length);
    }
    if (id.indexOf('?') > -1) {
      temp = id.split('?');
      id = temp[0];
    }
    if (id.indexOf('&') > -1) {
      temp = id.split('&');
      id = temp[0];
    }
    if (id.indexOf('-') > -1) {
      temp = id.split('-');
      id = temp[temp.length - 1];
    }
    return id;
  }

  canPermission(permission:any) {
    const account = localStorage.getItem('currentSmmAccount') ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
    if (account.admin) {
      return true;
    } else {
      if (account.role) {
        for (var j = 0; j < account.role.length; j++) {
          const arrPermissions = (account.role[j].value) ? account.role[j].value : null;
          if (arrPermissions) {
            for (var i = 0; i < arrPermissions.length; i++) {
              if (arrPermissions[i].text == permission) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/global.service.ts